import { api } from "../../../utils/api";

// Get project list
export const fetchProjectsApi = (page = 1) => {
  return api.get(`/projects?page=${page}`);
};

// Get single project
export const fetchProjectByIdApi = async (id) => {
  const res = await api.get(`/projects/${id}`);
  return res.data;
};

// Create project
export const createProjectApi = async (payload) => {
  const res = await api.post("/projects", payload);
  return res.data;
};

// Update project
export const updateProjectApi = async (id, payload) => {
  const res = await api.put(`/projects/${id}`, payload);
  return res.data;
};

// Delete project
export const deleteProjectApi = async (id) => {
  const res = await api.delete(`/projects/${id}`);
  return res.data;
};

export const progressProjectApi = async (id) => {
  const res = await api.get(`/projects/${id}/progress`);
  return res.data;
}

// Upload project file
export const uploadProjectFileApi = async (projectId, data) => {
  const res = await api.post(`/projects/${projectId}/upload-file`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return res.data;
};

// Get files by project
export const fetchProjectFilesApi = async (projectId) => {
  const res = await api.get(`/projects/${projectId}/files`);
  return res.data;
};

// Delete file
export const deleteProjectFileApi = async (id) => {
  const res = await api.delete(`/projects/delete-file/${id}`);
  return res.data;
};

// Download file
export const downloadProjectFileApi = async (fileId) => {
  return api.get(`/projects/download-file/${fileId}`, {
    responseType: "blob",
  });
};